import './sentry';
import './posthog';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App';

if (typeof window !== 'undefined') {
  const brand = 'rgb(245,102,0)';
  const brandSoft = '#ff7a1a';
  const brandDark = '#c2410c';

  console.log(
    `%c
 ██████╗██╗  ██╗███████╗ ██████╗██╗  ██╗ ██████╗ ██╗   ██╗████████╗    ██████╗  █████╗  ██████╗ ███████╗
██╔════╝██║  ██║██╔════╝██╔════╝██║ ██╔╝██╔═══██╗██║   ██║╚══██╔══╝    ██╔══██╗██╔══██╗██╔════╝ ██╔════╝
██║     ███████║█████╗  ██║     █████╔╝ ██║   ██║██║   ██║   ██║       ██████╔╝███████║██║  ███╗█████╗
██║     ██╔══██║██╔══╝  ██║     ██╔═██╗ ██║   ██║██║   ██║   ██║       ██╔═══╝ ██╔══██║██║   ██║██╔══╝
╚██████╗██║  ██║███████╗╚██████╗██║  ██╗╚██████╔╝╚██████╔╝   ██║       ██║     ██║  ██║╚██████╔╝███████╗
 ╚═════╝╚═╝  ╚═╝╚══════╝ ╚═════╝╚═╝  ╚═╝ ╚═════╝  ╚═════╝    ╚═╝       ╚═╝     ╚═╝  ╚═╝ ╚═════╝ ╚══════╝
`,
    `
      font-family: monospace;
      font-size: 12px;
      line-height: 1.2;
      color: ${brand};
      text-shadow: 0 0 8px rgba(245,102,0,0.25);
    `,
  );

  console.log(
    `%cKnowledge base → https://checkoutpage.com/docs`,
    `color: ${brandSoft}; font-weight: 600;`,
  );

  console.log(
    `%cAPI Docs → https://checkoutpage.com/docs/api`,
    `color: ${brandSoft}; font-weight: 600;`,
  );

  console.log(`%cCareers → jobs@checkoutpage.com`, `color: ${brandSoft}; font-weight: 600;`);

  console.log(`%cWant something else? → support@checkoutpage.com`, `color: ${brandDark};`);
}

const container = document.getElementById('root');

const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(<App />);
